/* eslint-disable react/forbid-prop-types */
import React from "react";
import PropTypes from "prop-types";
import { Input } from "reactstrap";

const BillingStateDropdown = ({ billing, setBilling, valid }) => {
  const stateArray = [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "District Of Columbia",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming"
  ];

  return (
    <Input
      type="select"
      required
      value={billing.stateName || ""}
      className="custom-dropdown"
      id="billingState"
      onChange={e => {
        setBilling({
          ...billing,
          ...{ stateName: e.target.value }
        });
      }}
      invalid={valid.stateName === false}
    >
      <option value="" hidden>
        Choose
      </option>
      {stateArray.map(state => (
        <option
          className="custom-dropdown-item"
          id={`billingDropdownItem-${state}`}
          key={`state-${state}`}
          onClick={() =>
            setBilling({
              ...billing,
              ...{
                stateName: state
              }
            })
          }
        >
          {state}
        </option>
      ))}
    </Input>
  );
};

BillingStateDropdown.propTypes = {
  billing: PropTypes.shape({
    stateName: PropTypes.string
  }),
  setBilling: PropTypes.func,
  valid: PropTypes.shape({
    stateName: PropTypes.bool
  })
};

BillingStateDropdown.defaultProps = {
  billing: undefined,
  setBilling: undefined,
  valid: undefined
};

export default BillingStateDropdown;
